import React from "react";
import { siteConfig } from "../../config/siteConfig";

const Pricing = ({ onRegisterClick }) => {
  const { pricing } = siteConfig;
  const plan = pricing.plan;

  return (
    <section id="pricing" className="relative py-20 bg-slate-50 overflow-hidden">
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div
          className="absolute inset-0 opacity-[0.15]"
          style={{
            backgroundImage: `radial-gradient(#0f172a 1px, transparent 1px)`,
            backgroundSize: "32px 32px",
          }}
        />
        <div className="absolute -top-[10%] -left-[10%] w-[40%] h-[40%] rounded-full bg-emerald-100 blur-[120px] opacity-60" />
        <div className="absolute -bottom-[10%] -right-[10%] w-[40%] h-[40%] rounded-full bg-teal-50 blur-[120px] opacity-60" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-6">
            {pricing.eyebrowTitle1} <br />
            <span className="text-emerald-600">{pricing.eyebrowTitle2}</span>
          </h2>
          <p className="text-xl text-slate-600 font-medium">{pricing.eyebrowSubtitle}</p>
        </div>

        <div className="max-w-md mx-auto">
          <div className="relative bg-white rounded-[2.5rem] ring-2 ring-emerald-600 shadow-[10px_10px_0px_0px_rgba(4,120,87,1)] p-8 md:p-10 hover:translate-x-1 hover:-translate-y-1 transition-all">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 px-5 py-1.5 bg-gradient-to-r from-emerald-600 to-teal-600 text-white text-xs font-black uppercase tracking-widest rounded-full shadow-lg">
              Todo incluido
            </div>
            <div className="mb-8 mt-2">
              <h3 className="text-2xl font-black text-slate-900 mb-2">{plan.name}</h3>
              <p className="text-slate-500 text-sm font-medium">{plan.description}</p>
            </div>

            <div className="mb-10">
              <div className="flex items-baseline gap-1">
                <span className="text-7xl font-black text-slate-900">
                  {plan.currency}{plan.price}
                </span>
                <span className="text-xl text-slate-400 font-bold">{plan.period}</span>
              </div>
              <p className="text-sm font-bold text-emerald-600 mt-3 flex items-center gap-2">
                <span className="w-2 h-2 bg-emerald-600 rounded-full animate-pulse" />
                Cancela cuando quieras, sin compromiso
              </p>
            </div>

            <div className="space-y-4 mb-10">
              {plan.features.map((feature, idx) => (
                <div key={idx} className="flex items-center gap-3">
                  <svg className="w-6 h-6 text-emerald-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" />
                  </svg>
                  <span className="text-slate-700 font-bold text-sm">{feature}</span>
                </div>
              ))}
            </div>

            <button onClick={onRegisterClick} className="w-full py-5 rounded-2xl font-black text-xl bg-slate-900 text-white hover:bg-emerald-600 shadow-xl transition-all active:scale-95">
              {plan.ctaLabel}
            </button>
            <p className="mt-4 text-center text-xs font-semibold text-slate-500">
              Cancela en 1 clic desde tu panel. Sin permanencia.
            </p>

            <div className="mt-8 flex flex-col items-center gap-4">
              <p className="text-[11px] text-slate-400 font-bold uppercase tracking-widest">
                Simulador tipo examen oficial Serie 100
              </p>
            </div>
          </div>
        </div>

        <div className="relative z-10 mt-12 text-center flex flex-col items-center gap-6">
          <div className="flex items-center justify-center gap-8 opacity-40 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-500">
            <img src="https://cdn.simpleicons.org/visa/slate-900" alt="Visa" className="h-6 w-auto" />
            <img src="https://cdn.simpleicons.org/mastercard/slate-900" alt="Mastercard" className="h-8 w-auto" />
          </div>
          <div className="flex flex-col items-center gap-2">
            <div className="flex items-center gap-2 text-emerald-600">
              <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              <span className="text-xs font-bold uppercase tracking-widest">Pago 100% Seguro</span>
            </div>
            <p className="text-slate-400 text-[10px] font-medium max-w-xs leading-relaxed">
              Tus datos están protegidos por encriptación SSL de 256 bits. No almacenamos los datos de tu tarjeta.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
